import { 
  SET_TIPOS_GRUPO_PLANES,
  SET_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION_BYID,
  LOADING_TIPOS_PUBLICACION
} from './types';
import { getTiposPublicacion } from '../api/axios';


export const setTiposPublicacion = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_PUBLICACION,
    payload: params,
  });
}

export const setTiposGrupoPlanes = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_GRUPO_PLANES,
    payload: params,
  });
}

export const fetchTiposPublicacionAdm = (request) => async dispatch => { 

  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  try {
    const response = await getTiposPublicacion(request);
    dispatch({
      type: FETCH_TIPOS_PUBLICACION,
      payload: response
    });
  } catch (error) {
    console.log("Error" + error)
  } finally {
    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  }
}

export const fetchTiposPublicacionAdmById = (request) => async dispatch => {

  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  let array = getTiposPublicacion(request);
  array.then((value) => {

    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });

    dispatch({
      type: FETCH_TIPOS_PUBLICACION_BYID,
      payload: value
    });
  })
}